module.exports = __webpack_public_path__ + "static/media/trash.53b83035.svg";